import {custCareNum} from "../popups/contactCustCare";

export const fmtPhoneNum = num => /^\d{10}$/.test(num) ?
	num.substring(0, 3) + '-' + num.substring(3, 6) + '-' + num.substring(6) : num;

export const stripNonNums = str => str?.replace(/[^\d]/g, '');

export const dispPhoneNum = num => num !== custCareNum ? fmtPhoneNum(num) : "Customer Service";
